import { TObject } from '../../../../infrastructure/type-extensions';
import { FormFieldInputSelect } from './form-field-input-select';
import { FormFieldInputText } from './form-field-input-text';
import { FormFieldInputToggle } from './form-field-input-toggle';
import { FormFieldInputTextArea } from './form-field-input-texarea';

enum FromFieldInputs {
    TEXT = 'Text',
    SELECT = 'Select',
    TOGGLE = 'Toggle',
    TEXTAREA = 'Textarea'
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FormFieldInput: TObject<(props: any) => JSX.Element> = {
    [FromFieldInputs.TEXT]: FormFieldInputText,
    [FromFieldInputs.SELECT]: FormFieldInputSelect,
    [FromFieldInputs.TOGGLE]: FormFieldInputToggle,
    [FromFieldInputs.TEXTAREA]: FormFieldInputTextArea
};

export { FormFieldInput };
